import React from 'react'
import SelectParentNew from "../../select-parent-new";
import SelectParentsNew from "../../select-parents-new";
import ProjectFinder from "../../../../gd-components/finder/project/project-finder"

type Props = {
    className?: string

    parent              : SelectParentNew | SelectParentsNew | ProjectFinder
}


export default function ProjectSelect_CompanyNoProjects(props: Props) {
    return (
        <div className="flex-column-center-center p-20">
            <div className="ui5-txt-default">
                There are no projects in your organization
            </div>

            {gd.ac.check.createRootProject() &&
                <div className="ui5-txt-link m-t-10"
                     onClick={props.parent.onNewProjectClick}>
                    + New project
                </div>}
        </div>
    )

}
